import { SVGFC } from '@repo/toolkit/types'

const UserIcon: SVGFC = ({ color, ...props }) => {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M15.9914 4.56858H13.379C12.9266 3.70808 12.0424 3.10191 11.0007 3.10191C9.95887 3.10191 9.07471 3.70808 8.62234 4.56858H6.00991C4.89923 4.56858 4.01988 5.49622 4.01988 6.59935V16.866C4.01988 17.9691 4.89923 18.8968 6.00991 18.8968H15.9914C17.1021 18.8968 17.9814 17.9691 17.9814 16.866V6.59935C17.9814 5.49622 17.1021 4.56858 15.9914 4.56858ZM11.0007 5.69678C11.0664 5.69678 11.1495 5.75914 11.1495 5.86602C11.1495 5.97289 11.0664 6.03525 11.0007 6.03525C10.9349 6.03525 10.8518 5.97289 10.8518 5.86602C10.8518 5.75914 10.9349 5.69678 11.0007 5.69678ZM11.0007 8.63012C11.8578 8.63012 12.5754 9.34514 12.5754 10.266C12.5754 11.1869 11.8578 11.9019 11.0007 11.9019C10.1436 11.9019 9.42587 11.1869 9.42587 10.266C9.42587 9.34514 10.1436 8.63012 11.0007 8.63012ZM7.28698 16.3019V15.8393C7.28698 15.6718 7.36477 15.4832 7.58418 15.2697C7.80693 15.0529 8.1406 14.8477 8.55075 14.6705C9.37394 14.3149 10.3674 14.1301 11.0007 14.1301C11.6339 14.1301 12.6274 14.3149 13.4506 14.6705C13.8607 14.8477 14.1944 15.0529 14.4171 15.2697C14.6365 15.4832 14.7143 15.6718 14.7143 15.8393V16.3019H7.28698Z"
        stroke={color}
        strokeWidth="1.12821"
      />
    </svg>
  )
}

export default UserIcon
